<!-- Lista de tareas -->
<div [ngClass]="obtenerClaseEstado(lista.orden)"
  class="rounded-xl p-4 w-80 flex-shrink-0 shadow-md transition-all duration-300 ">

  <!-- Título de la lista -->
  <h3 class="text-base font-bold mb-4 text-center tracking-wide uppercase">
    {{ lista.titulo }}
  </h3>

  <div cdkDropList [cdkDropListData]="lista.tareas" [cdkDropListConnectedTo]="listasConectadas" [id]="lista.id"
    class="flex flex-col gap-2 min-h-[30px]" (cdkDropListDropped)="moverTarea($event)">

    <!-- Tarea -->
    <div *ngFor="let tarea of lista.tareas" cdkDrag (click)="abrirModalTarea(tarea)"
      class="bg-slate-100 dark:bg-slate-700 px-3 py-2 rounded-md shadow-sm cursor-move text-sm transition-all duration-200 hover:scale-[1.01] hover:shadow-md">
      {{ tarea.titulo }}

      <!-- Previsualización flotante -->
      <ng-template cdkDragPreview>
        <div class="bg-white dark:bg-slate-600 p-2 rounded-md shadow-lg text-sm border border-gray-300 w-[260px]">
          {{ tarea.titulo }}
        </div>
      </ng-template>

      <!-- Espacio reservado -->
      <ng-template cdkDragPlaceholder>
        <div class="opacity-30 border-2 border-dashed border-blue-400 bg-blue-100 dark:bg-blue-800 h-10 rounded-md">
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Formulario para agregar nueva tarea -->
  <div class="mt-4 flex items-start gap-2" *ngIf="agregandoTarea">
    <!-- Textarea -->
    <textarea [(ngModel)]="nuevoTitulo" placeholder="Escribe una nueva tarea..." rows="2"
      class="flex-1 text-sm text-slate-900 dark:text-white dark:bg-slate-700 bg-slate-100 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none shadow-sm"></textarea>

    <!-- Confirmar tarea -->
    <button (click)="confirmarTarea()"
      class="p-2 rounded-full bg-green-600 hover:bg-green-700 transition-colors shadow-md">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </button>

    <!-- Cancelar tarea -->
    <button (click)="cancelarTarea()" class="p-2 rounded-full bg-red-500 hover:bg-red-600 transition-colors shadow-md">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Botón para mostrar formulario -->
  <button *ngIf="!agregandoTarea" (click)="mostrarInputTarea()"
    class="mt-3 text-sm hover:underline focus:outline-none text-white/90">
    + Añadir Tarea
  </button>
</div>